<form *ngIf="formData$ | async; let formData; else loading"
  [formGroup]="formData.form" (ngSubmit)="onSubmit()">
  <app-form-fields [formData]="formData"></app-form-fields>
  <button *ngIf="false" mat-flat-button color="accent" type="button" (click)="reset()" i18n>Reset</button>

</form>
<ng-template #loading>
    <div i18n>Loading ...</div>
</ng-template>
